/*
 * Product page, Maison Vallier layout: the grey shipping strip shows a single dispatch date, the next
 * working day ("mié. 28 oct."; Saturday and Sunday move to Monday). The delivery-estimate block of
 * snippets/product-conversion-details.liquid writes a two-day range into the same element, so the
 * date is set again whenever that element changes.
 */

(function() {
  const dispatchDate = () => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    if (date.getDay() === 6) date.setDate(date.getDate() + 2);
    if (date.getDay() === 0) date.setDate(date.getDate() + 1);

    const weekday = new Intl.DateTimeFormat('es-ES', {weekday: 'short'}).format(date).replace('.', '');
    const month = new Intl.DateTimeFormat('es-ES', {month: 'short'}).format(date).replace('.', '');
    return `${weekday}. ${date.getDate()} ${month}.`;
  };

  const apply = () => {
    const text = dispatchDate();
    document.querySelectorAll('[data-cp-delivery-date]').forEach((element) => {
      if (element.textContent !== text) element.textContent = text;

      if (!element.cpDateObserver) {
        element.cpDateObserver = new MutationObserver(() => {
          if (element.textContent !== text) element.textContent = text;
        });
        element.cpDateObserver.observe(element, {childList: true, characterData: true, subtree: true});
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
